import { render, staticRenderFns } from "./DealCustomerIdentityVerificationStatus.vue?vue&type=template&id=9c593b1c&scoped=true"
import script from "./DealCustomerIdentityVerificationStatus.vue?vue&type=script&lang=js"
export * from "./DealCustomerIdentityVerificationStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c593b1c",
  null
  
)

export default component.exports